import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=2618796c&scoped=true"
import script from "./CardFooter.vue?vue&type=script&lang=js"
export * from "./CardFooter.vue?vue&type=script&lang=js"
import style0 from "./CardFooter.vue?vue&type=style&index=0&id=2618796c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2618796c",
  null
  
)

export default component.exports